module.exports = __webpack_public_path__ + "img/E30-2.6a90a3b5.png";